import TableRow from "@mui/material/TableRow";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import { ASSETS_GROUP } from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import TableContainer from "../../../../../components/Tables/TableContainer";
import { useFormContext } from "react-hook-form";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";

const GoogleAssetsGroupRow = ({
  indexCampaign,
  indexAssetsGroup,
  assetsGroupID,
  data,
  columns,
}) => {
  const { campaign } = useFormContext();
  const { t } = useTranslationApp();

  const assetsGroups = campaign.assetsGroups || [];
  const foundAssetsGroup = assetsGroups.find(
    (assetsGroup) => assetsGroup.id === assetsGroupID
  );

  return (
    <>
      <TableContainer
        hasPagination={false}
        rounded={false}
        hasMarginBottom={false}
        keys={[""]}
      >
        <TableRow>
          <TableCell indexRow={indexCampaign} sx={{ width: 25 }} level={3} />
          {columns.map((col) => (
            <TableCell
              key={col.key}
              indexRow={indexCampaign}
              sx={{ width: 192, maxWidth: 192, minWidth: 192 }}
            >
              {(() => {
                switch (col.key) {
                  case "platform":
                    return (
                      foundAssetsGroup?.name ||
                      `${t(ASSETS_GROUP)} ${indexAssetsGroup + 1}`
                    );
                  case "spend":
                    return renderMetricValue(
                      data.spend,
                      col.key,
                      data.currency
                    );
                  case "impressions":
                    return renderMetricValue(
                      data.impressions,
                      col.key,
                      data.currency
                    );
                  case "click":
                    return renderMetricValue(
                      data.click,
                      col.key,
                      data.currency
                    );
                  case "ctr":
                    return renderMetricValue(data.ctr, col.key, data.currency);
                  case "mainAction":
                    return renderMetricValue(
                      data.mainAction,
                      col.key,
                      data.currency
                    );
                  case "costPerMainAction":
                    return renderMetricValue(
                      data.costPerMainAction,
                      col.key,
                      data.currency
                    );
                  case "cpc":
                    return renderMetricValue(
                      (data.cpc || 0).toFixed(2),
                      col.key,
                      data.currency
                    );
                  case "cpm":
                    return renderMetricValue(
                      (data.cpm || 0).toFixed(2),
                      col.key,
                      data.currency
                    );
                  default:
                    return renderMetricValue(
                      data[col.key],
                      col.key,
                      data.currency
                    );
                }
              })()}
            </TableCell>
          ))}
        </TableRow>
      </TableContainer>
    </>
  );
};

export default GoogleAssetsGroupRow;
